module.exports = __webpack_public_path__ + "static/img/case2.d6028499.jpg";